import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import {
  getActivitiesByOrderId,
  getOrderDetail,
  getOrders as getOrdersApi,
  updateOrderQuantity,
  updateOrderStatus,
  updateOrderStatusExtendTime,
  updateOrderStatusTime,
  updateProductAvailabilty,
} from "../../helpers/backend_helper";
import { toast } from "react-toastify";

export const getOrders = createAsyncThunk(
  "order/get",
  async ({ status, keyword }: { status: string; keyword: string }) => {
    try {
      const response = await getOrdersApi(1, 10, status, keyword);
      const { data, counts } = response.data;
      return { orders: data, counts };
    } catch (error) {
      throw error;
    }
  }
);

export const getActivies = createAsyncThunk(
  "order/getActivies",
  async ({orderId }: { orderId: string; }) => {
    try {
      const response = await getActivitiesByOrderId(orderId);
      const data = response.data;
      return { activies: data };
    } catch (error) {
      throw error;
    }
  }
);

export const fetchOrderDetail = createAsyncThunk(
  "order/fetchDetail",
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await getOrderDetail(id);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async ({
    orderId,
    status,
    reason,
  }: {
    orderId: string;
    status: string;
    reason?: string;
  }) => {
    try {
      const response = await updateOrderStatus(orderId, status, reason);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateOrderTime = createAsyncThunk(
  "order/updateOrderTime",
  async ({
    orderId,
    status,
    preparingTime,
    sellerCancellationReason,
    orderPackageImage,
  }: {
    orderId: string;
    status?: string;
    preparingTime?: any;
    sellerCancellationReason?: any;
    orderPackageImage?: any;
  }) => {
    try {
      const response = await updateOrderStatusTime(
        orderId,
        status,
        preparingTime,
        sellerCancellationReason,
        orderPackageImage
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateExtendTime = createAsyncThunk(
  "order/updateExtendOrderTime",
  async ({
    orderId,
    orderAcceptTime,
  }: {
    orderId: string;
    orderAcceptTime?: any;
  }) => {
    try {
      const response = await updateOrderStatusExtendTime(
        orderId,
        orderAcceptTime
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateOrderQuantityApi = createAsyncThunk(
  "order/updateOrderQuantity",
  async (order: any, { rejectWithValue }) => {
    try {
      const orderData = {
        orderId: order.orderId,
        productId: order.productId,
        quantity: order.quantity,
      };
      const response: any = await updateOrderQuantity(orderData);
      if (response?.data && response?.isSuccess) {
        return response.data;
      } else {
        toast.error(response.message, { autoClose: 1000 });
        return rejectWithValue(response?.message || "Order updated failed");
      }
    } catch (error: any) {
      console.error("Error creating folder:", error);
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);

export const updateProductAvailabiltyApi = createAsyncThunk(
  "order/updateOrderAvailablity",
  async (order: any, { rejectWithValue }) => {
    try {
      const orderData = {
        orderId: order.orderId,
        products: [
          {
            productId: order.productId,
            reason: order.reason,
          },
        ],
      };
      const response: any = await updateProductAvailabilty(orderData);
      if (response?.data && response?.isSuccess) {
        return response.data;
      } else {
        toast.error(response.message, { autoClose: 1000 });
        return rejectWithValue(response?.message || "Order updated failed");
      }
    } catch (error: any) {
      console.error("Error creating folder:", error);
      return rejectWithValue(error.message || "Unexpected error occurred");
    }
  }
);
